export const CalendarGroup=[
    {
        "ElementType": "Text",
        "isElementSelected": false,
        "IsElementLocked": false,
        "IsElementPrivate": false,
        "IsElementDragable": false,
        "isElementResizeAble": false,
        "IsTimeField":true,
        "ElementData": "<p><strong style=\"font-weight: 900;\">9:00 AM </strong></p>",
        "Styles": [
          {
            "ElementWidth": 147,
            "ElementHeight": 65,
            "ElementTop": 230,
            "ElementLeft": 55,
            "ElementZIndex": 10,
            "ElementRotation": 0,
            "ElementMinHeight": 30,
            "ElementMinWidth": 100,
            "ElementBorderPatteren": "none",
            "ElementBorderColor": "#000000",
            "ElementBorderWidth": 1,
            "ElementBackgroundColor": "#ffffff",
            "ElementBackgroundImage": null,
            "ElementBorderImage": null,
            "ElementBackgroundImageRepeatStatus": false,
            "ElementBorderIsImage": false,
            "ElementBorderRadius": 0,
            "ElementBorderImageName": null,
            "ElementBackgroundImageName": null,
            "ElementOpacity": 0,
            "ElementFontFamily": "Lato",
            "ElementFontSize": 19,
            "ElementFontStyle": "Normal",
            "ElementFontWeight": 900,
            "ElementLetterSpacing": 1,
            "ElementLineHeight": 1.5,
            "ElementTextColor": "#000000",
            "ElementTextAlignment": "justify"
          }
        ]
      },
      {
        "ElementType": "Text",
        "isElementSelected": false,
        "IsElementLocked": false,
        "IsElementPrivate": false,
        "IsElementDragable": false,
        "isElementResizeAble": false,
        "IsTimeField":false,
        "ElementData": "<p>Bingo, Multi Purpose Room in the multipurpose room the event</p>",
        "Styles": [
          {
            "ElementWidth": 540,
            "ElementHeight": 65,
            "ElementTop": 230,
            "ElementLeft": 216,
            "ElementZIndex": 10,
            "ElementRotation": 0,
            "ElementMinHeight": 30,
            "ElementMinWidth": 100,
            "ElementBorderPatteren": "none",
            "ElementBorderColor": "#000000",
            "ElementBorderWidth": 1,
            "ElementBackgroundColor": "#ffffff",
            "ElementBackgroundImage": null,
            "ElementBorderImage": null,
            "ElementBackgroundImageRepeatStatus": false,
            "ElementBorderIsImage": false,
            "ElementBorderRadius": 0,
            "ElementBorderImageName": null,
            "ElementBackgroundImageName": null,
            "ElementOpacity": 0,
            "ElementFontFamily": "Lato",
            "ElementFontSize": 19,
            "ElementFontStyle": "Normal",
            "ElementFontWeight": 200,
            "ElementLetterSpacing": 1,
            "ElementLineHeight": 1.5,
            "ElementTextColor": "#000000",
            "ElementTextAlignment": "justify"
          }
        ]
      }
];


export const  MenuGroup=[
    {
        "ElementType": "Text",
        "isElementSelected": false,
        "IsElementLocked": false,
        "IsElementPrivate": false,
        "IsElementDragable": false,
        "isElementResizeAble": false,
        "isMealField":true,
        "ElementData": "<p><strong style=\"font-weight: 900;\">Breakfast</strong></p>",
        "Styles": [
          {
            "ElementWidth": 293,
            "ElementHeight": 57,
            "ElementTop": 270,
            "ElementLeft": 241,
            "ElementZIndex": 10,
            "ElementRotation": 0,
            "ElementMinHeight": 30,
            "ElementMinWidth": 100,
            "ElementBorderPatteren": "none",
            "ElementBorderColor": "#000000",
            "ElementBorderWidth": 1,
            "ElementBackgroundColor": "#ffffff",
            "ElementBackgroundImage": null,
            "ElementBorderImage": null,
            "ElementBackgroundImageRepeatStatus": false,
            "ElementBorderIsImage": false,
            "ElementBorderRadius": 0,
            "ElementBorderImageName": null,
            "ElementBackgroundImageName": null,
            "ElementOpacity": 0,
            "ElementFontFamily": "Lato",
            "ElementFontSize": 30,
            "ElementFontStyle": "Normal",
            "ElementFontWeight":200,
            "ElementLetterSpacing": 1,
            "ElementLineHeight": 1.5,
            "ElementTextColor": "#000000",
            "ElementTextAlignment": "center"
          }
        ]
      },
      {
        "ElementType": "Text",
        "isElementSelected": false,
        "IsElementLocked": false,
        "IsElementPrivate": false,
        "IsElementDragable": false,
        "isElementResizeAble": false,
        "isMealField":false,
        "ElementData": "<p>Homemade buttermilk pancakes, applewood smoked bacon, hashbrowns and fresh fruit</p>",
        "Styles": [
          {
            "ElementWidth": 662,
            "ElementHeight": 110,
            "ElementTop": 330,
            "ElementLeft": 57,
            "ElementZIndex":10,
            "ElementRotation": 0,
            "ElementMinHeight": 30,
            "ElementMinWidth":100,
            "ElementBorderPatteren": "none",
            "ElementBorderColor": "#000000",
            "ElementBorderWidth": 1,
            "ElementBackgroundColor": "#ffffff",
            "ElementBackgroundImage": null,
            "ElementBorderImage": null,
            "ElementBackgroundImageRepeatStatus": false,
            "ElementBorderIsImage": false,
            "ElementBorderRadius": 0,
            "ElementBorderImageName": null,
            "ElementBackgroundImageName": null,
            "ElementOpacity": 0,
            "ElementFontFamily": "Lato",
            "ElementFontSize": 23,
            "ElementFontStyle": "Normal",
            "ElementFontWeight": 200,
            "ElementLetterSpacing": 1,
            "ElementLineHeight":1.5,
            "ElementTextColor": "#000000",
            "ElementTextAlignment": "center"
          }
        ]
      },
];